const truncateText = (text: string, maxWords: number) => {
  const words = text.split(' ');
  if (words.length <= maxWords) {
    return text;
  }
  return `${words.slice(0, maxWords).join(' ')}...`;
};

export default truncateText;
